import { TimeOffCategoryPolicySchema } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import {
  ApiTimeOffPeriodTrackingTime,
  ApiTimeOffPolicyStartBalanceType,
} from "@/types/time-off/time-off-policy.types.ts";
import { Box, Radio, Stack, Title } from "@skailer-com/uikit";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface TimeOffPolicyStartBalanceProps {
  formHook: UseFormReturn<TimeOffCategoryPolicySchema>;
  periodTrackType?: ApiTimeOffPeriodTrackingTime;
}

export function TimeOffPolicyStartBalance({
  formHook,
  periodTrackType,
}: TimeOffPolicyStartBalanceProps) {
  const { t } = useTranslation();
  const { control } = formHook;

  const isHours = periodTrackType === ApiTimeOffPeriodTrackingTime.hours;

  return (
    <Stack>
      <Title
        header={t("time_off:start_balance_type_title")}
        caption={t("time_off:start_balance_type_description")}
        size={"xs"}
        paddingBottom
      />
      <Box variant={"border"}>
        <Controller
          render={({ field: { value, onChange } }) => (
            <>
              <Radio
                value={ApiTimeOffPolicyStartBalanceType.proportional_accrual}
                checked={value == ApiTimeOffPolicyStartBalanceType.proportional_accrual}
                onChange={() => {
                  onChange(ApiTimeOffPolicyStartBalanceType.proportional_accrual);
                }}
                title={t("time_off:start_balance_type_proportional_title")}
                caption={t("time_off:start_balance_type_proportional_caption", {
                  units: isHours
                    ? t("time_off:hours_genitive").toLowerCase()
                    : t("time_off:days_genitive").toLowerCase(),
                  units_cap: isHours ? t("time_off:hours") : t("time_off:days"),
                })}
              />
              <Radio
                value={ApiTimeOffPolicyStartBalanceType.full_accrual_amount}
                checked={value == ApiTimeOffPolicyStartBalanceType.full_accrual_amount}
                onChange={() => {
                  onChange(ApiTimeOffPolicyStartBalanceType.full_accrual_amount);
                }}
                title={t("time_off:start_balance_type_full_title")}
                caption={t("time_off:start_balance_type_full_caption", {
                  units: isHours
                    ? t("time_off:hours").toLowerCase()
                    : t("time_off:days").toLowerCase(),
                })}
              />
            </>
          )}
          control={control}
          name={"start_balance_type"}
        />
      </Box>
    </Stack>
  );
}
